import { Navigate, useRoutes } from "react-router-dom";

import {
  DashboardLayout,
  AuthGuard,
  GuestGuard,
  MainLayout,
  SimpleLayout,
  CompactLayout,
  BillingDetailsPage,
  ClassSessionReservationsPage,
  AnalyticsPage,
  DeleteAccountInstructions,
  PrivacyPolicy,
  StudentStars,
  Reviews,
} from "./elements";
// config
import { PATH_AFTER_LOGIN } from "../config-global";
//
import {
  // Auth
  LoginPage,
  RegisterPage,
  VerifyCodePage,
  NewPasswordPage,
  ResetPasswordPage,
  // Dashboard: General
  GeneralAppPage,
  GeneralFilePage,
  GeneralBankingPage,
  GeneralBookingPage,
  GeneralEcommercePage,
  GeneralAnalyticsPage,
  // Dashboard: User
  UserEditPage,
  UserCardsPage,
  StudentCreatePage,
  InstructorCreatePage,
  UserProfilePage,
  UserAccountPage,
  // Dashboard: Ecommerce
  EcommerceShopPage,
  EcommerceCheckoutPage,
  EcommerceProductListPage,
  EcommerceProductEditPage,
  EcommerceProductCreatePage,
  EcommerceProductDetailsPage,
  // Dashboard: Invoice
  InvoiceListPage,
  InvoiceDetailsPage,
  InvoiceCreatePage,
  InvoiceEditPage,
  // Dashboard: Blog
  BlogPostsPage,
  BlogPostPage,
  BlogNewPostPage,
  // Dashboard: FileManager
  FileManagerPage,
  // Dashboard: App
  ChatPage,
  MailPage,
  CalendarPage,
  KanbanPage,
  //
  BlankPage,
  PermissionDeniedPage,
  //
  Page500,
  Page403,
  Page404,
  HomePage,
  FaqsPage,
  CourseDrivePage,
  CourseFirstAid,
  CourseVkuPage,
  CourseMotoPage,
  AboutPage,
  Contact,
  PricingPage,
  PricePageCheck,
  PricePageCheckCoupon,
  PaymentPage,
  ComingSoonPage,
  MaintenancePage,
  //
  ComponentsOverviewPage,
  FoundationColorsPage,
  FoundationTypographyPage,
  FoundationShadowsPage,
  FoundationGridPage,
  FoundationIconsPage,
  //
  MUIAccordionPage,
  MUIAlertPage,
  MUIAutocompletePage,
  MUIAvatarPage,
  MUIBadgePage,
  MUIBreadcrumbsPage,
  MUIButtonsPage,
  MUICheckboxPage,
  MUIChipPage,
  MUIDataGridPage,
  MUIDialogPage,
  MUIListPage,
  MUIMenuPage,
  MUIPaginationPage,
  MUIPickersPage,
  MUIPopoverPage,
  MUIProgressPage,
  MUIRadioButtonsPage,
  MUIRatingPage,
  MUISliderPage,
  MUIStepperPage,
  MUISwitchPage,
  MUITablePage,
  MUITabsPage,
  MUITextFieldPage,
  MUITimelinePage,
  MUITooltipPage,
  MUITransferListPage,
  MUITreesViewPage,
  //
  DemoAnimatePage,
  DemoCarouselsPage,
  DemoChartsPage,
  DemoCopyToClipboardPage,
  DemoEditorPage,
  DemoFormValidationPage,
  DemoImagePage,
  DemoLabelPage,
  DemoLightboxPage,
  DemoMapPage,
  DemoMegaMenuPage,
  DemoMultiLanguagePage,
  DemoNavigationBarPage,
  DemoOrganizationalChartPage,
  DemoScrollbarPage,
  DemoSnackbarPage,
  DemoTextMaxLinePage,
  DemoUploadPage,
  DemoMarkdownPage,
  ProductsOverviewPage,
  ProductOverviewPage,
  RegisterDrivingLessons,
  PricePage,
  PaymentPageCheckStatus,
  StudentListPage,
  InstructorListPage,
  PricePageCheckReserve,
  // Sessions
  SessionsPage,
  NewSessionPage,
} from "./elements";
import EditSession from "src/pages/dashboard/classes/EditSession";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: "register",
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        // {
        //   path: "login-unprotected",
        //   element: (
        //     <GuestGuard>
        //       <LoginPage />
        //     </GuestGuard>
        //   ),
        // },
        // { path: "register-unprotected", element: <RegisterPage /> },
        {
          element: <CompactLayout />,
          children: [
            { path: "reset-password", element: <ResetPasswordPage /> },
            { path: "new-password", element: <NewPasswordPage /> },
            { path: "verify", element: <VerifyCodePage /> },
          ],
        },
      ],
    },
    // Dashboard
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "app", element: <GeneralAppPage /> },
        // { path: "ecommerce", element: <GeneralEcommercePage /> },
        // { path: "analytics", element: <GeneralAnalyticsPage /> },
        // { path: "banking", element: <GeneralBankingPage /> },
        // { path: "booking", element: <GeneralBookingPage /> },
        // { path: "file", element: <GeneralFilePage /> },
        // {
        //   path: "e-commerce",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/e-commerce/shop" replace />,
        //       index: true,
        //     },
        //     { path: "shop", element: <EcommerceShopPage /> },
        //     { path: "product/:name", element: <EcommerceProductDetailsPage /> },
        //     { path: "list", element: <EcommerceProductListPage /> },
        //     { path: "product/new", element: <EcommerceProductCreatePage /> },
        //     {
        //       path: "product/:name/edit",
        //       element: <EcommerceProductEditPage />,
        //     },
        //     { path: "checkout", element: <EcommerceCheckoutPage /> },
        //   ],
        // },
        {
          path: "sessions",
          children: [
            { element: <SessionsPage />, index: true },
            { path: "new-class-session", element: <NewSessionPage /> },
            { path: "edit-class-session/:id", element: <EditSession /> },
            {
              path: "class-session-reservations/:id",
              element: <ClassSessionReservationsPage />,
            },
          ],
        },
        // {
        //   path: "user",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/user/account" replace />,
        //       index: true,
        //     },
        //     { path: "profile", element: <UserProfilePage /> },
        //     { path: "cards", element: <UserCardsPage /> },
        //     { path: "new", element: <StudentCreatePage /> },
        //     { path: ":id/edit", element: <UserEditPage /> },
        //     { path: "account", element: <UserAccountPage /> },
        //   ],
        // },
        {
          path: "users",
          children: [
            {
              element: <Navigate to="/dashboard/users/students" replace />,
              index: true,
            },
            { path: "students", element: <StudentListPage /> },
            { path: "instructors", element: <InstructorListPage /> },
            { path: "students/new", element: <StudentCreatePage /> },
            {
              path: "students/edit/:studentId",
              element: <StudentCreatePage />,
            },
            {
              path: "students/contact-student/:studentId",
              element: <StudentCreatePage />,
            },
            { path: "instructors/new", element: <InstructorCreatePage /> },
            {
              path: "instructors/edit/:instructorId",
              element: <InstructorCreatePage />,
            },
            // {
            //   path: "contact",
            //   element: <ChatPage />,
            // },
          ],
        },
        // {
        //   path: "invoice",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/invoice/list" replace />,
        //       index: true,
        //     },
        //     { path: "list", element: <InvoiceListPage /> },
        //     { path: ":id", element: <InvoiceDetailsPage /> },
        //     { path: ":id/edit", element: <InvoiceEditPage /> },
        //     { path: "new", element: <InvoiceCreatePage /> },
        //   ],
        // },
        // {
        //   path: "blog",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/blog/posts" replace />,
        //       index: true,
        //     },
        //     { path: "posts", element: <BlogPostsPage /> },
        //     { path: "post/:title", element: <BlogPostPage /> },
        //     { path: "new", element: <BlogNewPostPage /> },
        //   ],
        // },
        // { path: "files-manager", element: <FileManagerPage /> },
        // {
        //   path: "mail",
        //   children: [
        //     {
        //       element: <Navigate to="/dashboard/mail/all" replace />,
        //       index: true,
        //     },
        //     { path: "label/:customLabel", element: <MailPage /> },
        //     { path: "label/:customLabel/:mailId", element: <MailPage /> },
        //     { path: ":systemLabel", element: <MailPage /> },
        //     { path: ":systemLabel/:mailId", element: <MailPage /> },
        //   ],
        // },
        // {
        //   path: "chat",
        //   children: [
        //     { element: <ChatPage />, index: true },
        //     { path: "new", element: <ChatPage /> },
        //     { path: ":conversationKey", element: <ChatPage /> },
        //   ],
        // },
        // { path: "calendar", element: <CalendarPage /> },
        // { path: "kanban", element: <KanbanPage /> },
        // { path: "permission-denied", element: <PermissionDeniedPage /> },
        // { path: "blank", element: <BlankPage /> },
      ],
    },
    // Main Routes
    {
      element: <MainLayout />,
      children: [
        { element: <HomePage />, index: true },
        { path: "about-us", element: <AboutPage /> },
        {
          path: "delete-account",
          element: <DeleteAccountInstructions />,
        },
        { path: "contact-us", element: <Contact /> },
        { path: "faqs", element: <FaqsPage /> },
        { path: "privacy-policy", element: <PrivacyPolicy /> },
        { path: "CourseDriving", element: <CourseDrivePage /> },
        { path: "CourseFirstAid", element: <CourseFirstAid /> },
        { path: "CourseVku", element: <CourseVkuPage /> },
        { path: "CourseMoto", element: <CourseMotoPage /> },
        { path: "RegisterDrivingLessons", element: <RegisterDrivingLessons /> },
        { path: "PricePage", element: <PricePage /> },
        { path: "PricePageCheck", element: <PricePageCheck /> },
        { path: "PricePageCheckReserve", element: <PricePageCheckReserve /> },
        { path: "PaymentPageCheckStatus", element: <PaymentPageCheckStatus /> },
        // {
        //   path: ":amountCoupon/PricePageCheckCoupon",
        //   children: [{ element: <PricePageCheckCoupon />, index: true }],
        // },
        { path: "billing", element: <BillingDetailsPage /> },
        //PricePage
        // Demo Components
        {
          path: "components",
          children: [
            { element: <ComponentsOverviewPage />, index: true },
            {
              path: "foundation",
              children: [
                {
                  element: (
                    <Navigate to="/components/foundation/colors" replace />
                  ),
                  index: true,
                },
                { path: "colors", element: <FoundationColorsPage /> },
                { path: "typography", element: <FoundationTypographyPage /> },
                { path: "shadows", element: <FoundationShadowsPage /> },
                { path: "grid", element: <FoundationGridPage /> },
                { path: "icons", element: <FoundationIconsPage /> },
              ],
            },
            {
              path: "mui",
              children: [
                {
                  element: <Navigate to="/components/mui/accordion" replace />,
                  index: true,
                },
                { path: "accordion", element: <MUIAccordionPage /> },
                { path: "alert", element: <MUIAlertPage /> },
                { path: "autocomplete", element: <MUIAutocompletePage /> },
                { path: "avatar", element: <MUIAvatarPage /> },
                { path: "badge", element: <MUIBadgePage /> },
                { path: "breadcrumbs", element: <MUIBreadcrumbsPage /> },
                { path: "buttons", element: <MUIButtonsPage /> },
                { path: "checkbox", element: <MUICheckboxPage /> },
                { path: "chip", element: <MUIChipPage /> },
                { path: "data-grid", element: <MUIDataGridPage /> },
                { path: "dialog", element: <MUIDialogPage /> },
                { path: "list", element: <MUIListPage /> },
                { path: "menu", element: <MUIMenuPage /> },
                { path: "pagination", element: <MUIPaginationPage /> },
                { path: "pickers", element: <MUIPickersPage /> },
                { path: "popover", element: <MUIPopoverPage /> },
                { path: "progress", element: <MUIProgressPage /> },
                { path: "radio-button", element: <MUIRadioButtonsPage /> },
                { path: "rating", element: <MUIRatingPage /> },
                { path: "slider", element: <MUISliderPage /> },
                { path: "stepper", element: <MUIStepperPage /> },
                { path: "switch", element: <MUISwitchPage /> },
                { path: "table", element: <MUITablePage /> },
                { path: "tabs", element: <MUITabsPage /> },
                { path: "textfield", element: <MUITextFieldPage /> },
                { path: "timeline", element: <MUITimelinePage /> },
                { path: "tooltip", element: <MUITooltipPage /> },
                { path: "transfer-list", element: <MUITransferListPage /> },
                { path: "tree-view", element: <MUITreesViewPage /> },
              ],
            },
            {
              path: "extra",
              children: [
                {
                  element: <Navigate to="/components/extra/animate" replace />,
                  index: true,
                },
                { path: "animate", element: <DemoAnimatePage /> },
                { path: "carousel", element: <DemoCarouselsPage /> },
                { path: "chart", element: <DemoChartsPage /> },
                {
                  path: "copy-to-clipboard",
                  element: <DemoCopyToClipboardPage />,
                },
                { path: "editor", element: <DemoEditorPage /> },
                {
                  path: "form-validation",
                  element: <DemoFormValidationPage />,
                },
                { path: "image", element: <DemoImagePage /> },
                { path: "label", element: <DemoLabelPage /> },
                { path: "lightbox", element: <DemoLightboxPage /> },
                { path: "map", element: <DemoMapPage /> },
                { path: "mega-menu", element: <DemoMegaMenuPage /> },
                { path: "multi-language", element: <DemoMultiLanguagePage /> },
                { path: "navigation-bar", element: <DemoNavigationBarPage /> },
                {
                  path: "organization-chart",
                  element: <DemoOrganizationalChartPage />,
                },
                { path: "scroll", element: <DemoScrollbarPage /> },
                { path: "snackbar", element: <DemoSnackbarPage /> },
                { path: "text-max-line", element: <DemoTextMaxLinePage /> },
                { path: "upload", element: <DemoUploadPage /> },
                { path: "markdown", element: <DemoMarkdownPage /> },
              ],
            },
          ],
        },
        {
          path: ":region",
          children: [
            { element: <ProductsOverviewPage />, index: true },
            { path: ":productName", element: <ProductOverviewPage /> },
          ],
        },
      ],
    },
    // Analytics
    {
      path: "analytics",
      children: [
        {
          element: <AnalyticsPage />,
          index: true,
        },
      ],
    },
    // Analytics
    {
      path: "student-stars",
      children: [
        {
          element: <StudentStars />,
          index: true,
        },
      ],
    },
    {
      path: "reviews",
      children: [
        {
          element: <Reviews />,
          index: true,
        },
      ],
    },
    // {
    //   element: <SimpleLayout />,
    //   children: [
    //     { path: "pricing", element: <PricingPage /> },
    //     { path: "payment", element: <PaymentPage /> },
    //   ],
    // },
    // {
    //   element: <CompactLayout />,
    //   children: [
    //     { path: "coming-soon", element: <ComingSoonPage /> },
    //     { path: "maintenance", element: <MaintenancePage /> },
    //     { path: "500", element: <Page500 /> },
    //     { path: "404", element: <Page404 /> },
    //     { path: "403", element: <Page403 /> },
    //   ],
    // },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
